<template>
    <template-card-v2
        :oneLog="oneLog"
        :linkedtype="linkedtype"
        :linkedid="linkedid"
        :hasHistory="false"
    >
        <template #label>
            <person-list-light
                :list="[contact]"
                :placeholder="oneLog.staffs.params.placeholder"
            ></person-list-light>
        </template>
        <template #icon>
            <CompassObject object="tracking" size="small" />
        </template>
        <template #content>
            <div class="flex-column flex-top mt-2 hp-10 lh-20 fs-3">
                <template v-if="isForm">
                    <span
                        >{{ $l10n.__('A soumis le formulaire:') }}
                        <span class="semibold"
                            >{{ tracking.form_id }} - {{ tracking.form_name }}</span
                        ></span
                    >
                    <span
                        >{{ $l10n.__('Depuis:') }}
                        <a :href="tracking.url" target="_blank">{{ tracking.url }}</a></span
                    >
                </template>
                <p v-else class="m-0 wp-9 ellipsis">
                    {{ $l10n.__('A visité:') }}
                    <a :href="tracking.url" target="_blank">{{ tracking.url }}</a>
                </p>
            </div>
        </template>
    </template-card-v2>
</template>

<script>
import TemplateCardV2 from './TemplateCardV2.vue';
import TimelineCardMixin from './TimelineCardMixin.js';
import PersonListLight from 'vcomponents/utilities/PersonListLight.vue';

export default {
    components: {
        TemplateCardV2,
        PersonListLight,
    },
    mixins: [TimelineCardMixin],
    computed: {
        tracking() {
            return this.oneLog.eventDetails;
        },
        isForm() {
            return this.tracking.type === 'form';
        },
        contact() {
            const contact = this.oneLog.linkeds.find((linked) => linked.type === 'people');
            return !_.isNil(contact)
                ? { fullName: contact.name }
                : { fullName: this.$store.getters.identity.name };
        },
    },
};
</script>
